import React from "react";
import { useIntl } from "react-intl";

//Components
import { Switch as Toggle, IconButton, Tooltip } from '@gpstrackit/gtc-react-controls';
import WarningController from './warningController';
import { Grid, Icon, Divider } from "@mui/material";

const DMS = (props) => {
    const { messages } = useIntl();
    const {
        deviceModelSelected,
        setFormDataCamera,
        setCameraChanges,
        formDataCamera,
        setErrors,
        errors,
        unit
    } = props

    //Variables
    let devideModelSupported = ["4K", "AIR2"]
    let dmsLevel = formDataCamera?.dms?.level === "OFF" ? true : formDataCamera?.noData

    if (!devideModelSupported.includes(unit?.deviceModel || deviceModelSelected?.id)) {
        return (
            <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 10 }}
            >
                <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                    <p style={{ opacity: 0.5 }}>{messages['cameraSetup_does_not_support']}</p>
                </Grid>
            </Grid>
        )
    }

    /* 
    
        {
                        !dmsLevel && devideModelSupported.includes(unit?.deviceModel || deviceModelSelected?.id) &&
                        <Grid item xs={12} className="camera-setup-general-container">
                            <label className="label-gtc-rc">{messages['cameraSetup_passenger_detection']}</label>
                            <Toggle
                                id="passenger-detection"
                                optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                                onChange={(value) => {
                                    let passengersInside = value ? "DEFAULT" : "OFF"
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        eventLevel: {
                                            ...prevData?.eventLevel,
                                            DMS: {
                                                ...prevData?.eventLevel?.DMS,
                                                PASSENGERS_INSIDE: passengersInside
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        eventLevel: {
                                            ...prevData?.eventLevel,
                                            DMS: {
                                                ...prevData?.eventLevel?.DMS,
                                                PASSENGERS_INSIDE: passengersInside
                                            }
                                        }
                                    }));
                                }}
                                checked={formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE && formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE !== "OFF"}
                                labelPosition="left"
                                style={{ display: 'flex', justifyContent: 'end' }}
                                isDisabled={formDataCamera?.noData}
                            />
                        </Grid>
                    }
    */

    return (
        <div style={{ marginTop: 5 }}>
            <Grid
                container
                direction="row"
                alignItems="center"
                style={{ marginBottom: 10 }}
            >
                {
                    dmsLevel && !formDataCamera?.noData &&
                    <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <p style={{ opacity: 0.5 }}>{messages['cameraSetup_dms_off']}</p>
                    </Grid>
                }
                <Grid item xs={5}></Grid>
                <Grid item xs={3} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_trigger']}</label>
                    <Tooltip title={`${messages['cameraSetup_trigger_description']}`} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                <Grid item xs={3} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_warning']}</label>
                    <Tooltip title={messages['cameraSetup_warning_description']} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                <Grid item xs={1} className="camera-setup-header">
                    <label className="label-gtc-rc">{messages['cameraSetup_audio']}</label>
                    <Tooltip title={`${messages['cameraSetup_audio_description']}`} placement="bottom">
                        <Icon className="camera-setup-helper-icon">help</Icon>
                    </Tooltip>
                </Grid>
                <Grid item xs={12}>
                    <p style={{ marginBottom: 0, opacity: 0.5 }}>{messages['cameraSetup_dms_lite']}</p>
                    <Divider style={{ marginBottom: 5 }} />
                </Grid>
                <Grid item xs={5}>{messages['cameraSetup_using_phone']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="using-phone-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let usingPhone = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        USING_PHONE: usingPhone
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        USING_PHONE: usingPhone
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.USING_PHONE === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        {
                            ((unit?.deviceModel && unit?.deviceModel !== "AIR1") || (deviceModelSelected?.id && deviceModelSelected?.id !== "AIR1")) &&
                            <WarningController
                                value={formDataCamera?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE}
                                onChange={(value) => {
                                    let currentErrors = errors
                                    if (value > 10 && !currentErrors.includes("USING_CELLPHONE")) {
                                        currentErrors.push("USING_CELLPHONE")
                                        setErrors(currentErrors)
                                    } else {
                                        let indexCount = currentErrors.findIndex((item) => item === "USING_CELLPHONE")
                                        if (indexCount > -1) {
                                            currentErrors.splice(indexCount, 1)
                                        }
                                        setErrors(currentErrors)
                                    }
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    USING_CELLPHONE: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE,
                                                        cnt: value,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    USING_CELLPHONE: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE,
                                                        ...formDataCamera?.advanced?.safetyAssistance?.alarm?.USING_CELLPHONE,
                                                        cnt: value || null,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                }}
                                isDisabled={dmsLevel || formDataCamera?.eventLevel?.DMS?.USING_PHONE === "OFF"}
                            />
                        }
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.USING_PHONE === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.USING_PHONE === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        USING_PHONE: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        USING_PHONE: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.USING_PHONE === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.USING_PHONE !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.USING_PHONE !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5}>{messages['cameraSetup_drowsy']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="drowsy-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let drowsiness = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DROWSINESS: drowsiness
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DROWSINESS: drowsiness
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.DROWSINESS === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.DROWSINESS === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.DROWSINESS === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DROWSINESS: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DROWSINESS: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.DROWSINESS === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.DROWSINESS !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.DROWSINESS !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5}>{messages['cameraSetup_no_seatbelt']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="no-seatbelt-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let noSeatbelt = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel.DMS,
                                        NO_SEATBELT: noSeatbelt
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        NO_SEATBELT: noSeatbelt
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.NO_SEATBELT === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        {
                            ((unit?.deviceModel && unit?.deviceModel !== "AIR1") || (deviceModelSelected?.id && deviceModelSelected?.id !== "AIR1")) &&
                            <WarningController
                                value={formDataCamera?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT}
                                onChange={(value) => {
                                    let currentErrors = errors
                                    if (value > 10 && !currentErrors.includes("NO_SEATBELT")) {
                                        currentErrors.push("NO_SEATBELT")
                                        setErrors(currentErrors)
                                    } else {
                                        let indexCount = currentErrors.findIndex((item) => item === "NO_SEATBELT")
                                        if (indexCount > -1) {
                                            currentErrors.splice(indexCount, 1)
                                        }
                                        setErrors(currentErrors)
                                    }
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    NO_SEATBELT: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT,
                                                        cnt: value,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    NO_SEATBELT: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT,
                                                        ...formDataCamera?.advanced?.safetyAssistance?.alarm?.NO_SEATBELT,
                                                        cnt: value || null,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                }}
                                isDisabled={dmsLevel || formDataCamera?.eventLevel?.DMS?.NO_SEATBELT === "OFF"}
                            />
                        }
                    </div>

                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.NO_SEATBELT === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.NO_SEATBELT === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        NO_SEATBELT: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        NO_SEATBELT: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.NO_SEATBELT === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.NO_SEATBELT !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.NO_SEATBELT !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                { /* daydreaming */}
                <Grid item xs={5}>{messages['cameraSetup_smoking']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="smoking-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let smoking = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        SMOKING: smoking
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        SMOKING: smoking
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.SMOKING === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.SMOKING === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.SMOKING === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        SMOKING: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        SMOKING: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.SMOKING === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.SMOKING !== "DEFAULT"}
                        className={(formDataCamera?.eventLevel?.DMS?.SMOKING !== "DEFAULT") ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                { /* daydreaming */}
                <Grid item xs={5}>{messages['cameraSetup_yawn']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="yawn-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let yawn = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        YAWN: yawn
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        YAWN: yawn
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.YAWN === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.YAWN === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.YAWN === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        YAWN: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        YAWN: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.YAWN === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.YAWN !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.YAWN !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5}>{messages['cameraSetup_distracted']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="distracted-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let distracted = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DISTRACTED: distracted
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DISTRACTED: distracted
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.DISTRACTED === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        {
                            ((unit?.deviceModel && unit?.deviceModel !== "AIR1") || (deviceModelSelected?.id && deviceModelSelected?.id !== "AIR1")) &&
                            <WarningController
                                value={formDataCamera?.advanced?.safetyAssistance?.alarm?.DISTRACTED}
                                onChange={(value) => {
                                    let currentErrors = errors
                                    if (value > 10 && !currentErrors.includes("DISTRACTED")) {
                                        currentErrors.push("DISTRACTED")
                                        setErrors(currentErrors)
                                    } else {
                                        let indexCount = currentErrors.findIndex((item) => item === "DISTRACTED")
                                        if (indexCount > -1) {
                                            currentErrors.splice(indexCount, 1)
                                        }
                                        setErrors(currentErrors)
                                    }
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    DISTRACTED: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.DISTRACTED,
                                                        cnt: value,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    DISTRACTED: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.DISTRACTED,
                                                        ...formDataCamera?.advanced?.safetyAssistance?.alarm?.DISTRACTED,
                                                        cnt: value || null,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                }}
                                isDisabled={dmsLevel || formDataCamera?.eventLevel?.DMS?.DISTRACTED === "OFF"}
                            />
                        }
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.DISTRACTED === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.DISTRACTED === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DISTRACTED: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DISTRACTED: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.DISTRACTED === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.DISTRACTED !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.DISTRACTED !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5}>{messages['cameraSetup_no_driver']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="no-driver-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let noDriver = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        NO_DRIVER: noDriver
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        NO_DRIVER: noDriver
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.NO_DRIVER === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        {
                            ((unit?.deviceModel && unit?.deviceModel !== "AIR1") || (deviceModelSelected?.id && deviceModelSelected?.id !== "AIR1")) &&
                            <WarningController
                                value={formDataCamera?.advanced?.safetyAssistance?.alarm?.NO_DRIVER}
                                onChange={(value) => {
                                    let currentErrors = errors
                                    if (value > 10 && !currentErrors.includes("NO_DRIVER")) {
                                        currentErrors.push("NO_DRIVER")
                                        setErrors(currentErrors)
                                    } else {
                                        let indexCount = currentErrors.findIndex((item) => item === "NO_DRIVER")
                                        if (indexCount > -1) {
                                            currentErrors.splice(indexCount, 1)
                                        }
                                        setErrors(currentErrors)
                                    }
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    NO_DRIVER: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.NO_DRIVER,
                                                        cnt: value,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    NO_DRIVER: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.NO_DRIVER,
                                                        ...formDataCamera?.advanced?.safetyAssistance?.alarm?.NO_DRIVER,
                                                        cnt: value || null,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                }}
                                isDisabled={dmsLevel || formDataCamera?.eventLevel?.DMS?.NO_DRIVER === "OFF"}
                            />
                        }
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.NO_DRIVER === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.NO_DRIVER === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        NO_DRIVER: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        NO_DRIVER: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.NO_DRIVER === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.NO_DRIVER !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.NO_DRIVER !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5} style={{ marginTop: 5, marginBottom: 5 }}>{messages['cameraSetup_idle_no_driver']}</Grid>
                <Grid item xs={3} style={{ marginTop: 5, marginBottom: 5 }}>
                    <Toggle
                        id="idle-no-driver-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let idleNoDriver = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        IDLE_NO_DRIVER: idleNoDriver
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        IDLE_NO_DRIVER: idleNoDriver
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.IDLE_NO_DRIVER === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3} style={{ marginTop: 5, marginBottom: 5 }}></Grid>
                <Grid item xs={1} style={{ marginTop: 5, marginBottom: 5 }}></Grid>
                {/* New */}
                <Grid item xs={5}>{messages['cameraSetup_passenger_detection']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="passenger-detection-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let passengersInside = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        PASSENGERS_INSIDE: passengersInside
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        PASSENGERS_INSIDE: passengersInside
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE && formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE !== "OFF"}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}></div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.PASSENGERS_INSIDE === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.PASSENGERS_INSIDE === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        PASSENGERS_INSIDE: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        PASSENGERS_INSIDE: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.PASSENGERS_INSIDE === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.PASSENGERS_INSIDE !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>

                <Grid item xs={5}>{messages['cameraSetup_passengers_no_seatbelt']}</Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="passenger-no-seatbelt-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let passengersInside = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        PASSENGERS_NO_SEATBELT: passengersInside
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        PASSENGERS_NO_SEATBELT: passengersInside
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT && formDataCamera?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT !== "OFF"}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel}
                    />
                </Grid>
                <Grid item xs={3}>
                    <div style={{ width: 70 }}>
                        {
                            ((unit?.deviceModel && unit?.deviceModel !== "AIR1") || (deviceModelSelected?.id && deviceModelSelected?.id !== "AIR1")) &&
                            <WarningController
                                value={formDataCamera?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT}
                                onChange={(value) => {
                                    let currentErrors = errors
                                    if (value > 10 && !currentErrors.includes("PASSENGERS_NO_SEATBELT")) {
                                        currentErrors.push("PASSENGERS_NO_SEATBELT")
                                        setErrors(currentErrors)
                                    } else {
                                        let indexCount = currentErrors.findIndex((item) => item === "PASSENGERS_NO_SEATBELT")
                                        if (indexCount > -1) {
                                            currentErrors.splice(indexCount, 1)
                                        }
                                        setErrors(currentErrors)
                                    }
                                    setFormDataCamera((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    PASSENGERS_NO_SEATBELT: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT,
                                                        cnt: value,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                    setCameraChanges((prevData) => ({
                                        ...prevData,
                                        advanced: {
                                            ...prevData?.advanced,
                                            safetyAssistance: {
                                                ...prevData?.advanced?.safetyAssistance,
                                                alarm: {
                                                    ...prevData?.advanced?.safetyAssistance?.alarm,
                                                    PASSENGERS_NO_SEATBELT: {
                                                        ...prevData?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT,
                                                        ...formDataCamera?.advanced?.safetyAssistance?.alarm?.PASSENGERS_NO_SEATBELT,
                                                        cnt: value || null,
                                                        enable: value ? true : false
                                                    }
                                                }
                                            }
                                        }
                                    }));
                                }}
                                isDisabled={dmsLevel || formDataCamera?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT === "OFF"}
                            />
                        }
                    </div>
                </Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.PASSENGERS_NO_SEATBELT === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.PASSENGERS_NO_SEATBELT === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        PASSENGERS_NO_SEATBELT: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        PASSENGERS_NO_SEATBELT: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.PASSENGERS_NO_SEATBELT === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT !== "DEFAULT" || dmsLevel}
                        className={(formDataCamera?.eventLevel?.DMS?.PASSENGERS_NO_SEATBELT !== "DEFAULT" || dmsLevel) ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={12}>
                    <p style={{ marginBottom: 0, opacity: 0.5 }}>DMS +</p>
                    <Divider style={{ marginBottom: 5 }} />
                </Grid>
                <Grid item xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                    {messages['cameraSetup_daydreaming']}
                    {
                        formDataCamera?.dms?.level === "LITE" &&
                        <Tooltip title={messages['cameraSetup_requires_dms_camera']} placement="bottom">
                            <Icon className="camera-setup-helper-icon">help</Icon>
                        </Tooltip>
                    }
                </Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="daydreaming-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let daydreaming = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DAYDREAMING: daydreaming
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        DAYDREAMING: daydreaming
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.DAYDREAMING === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel || formDataCamera?.dms?.level === "LITE"}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.DAYDREAMING === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.DAYDREAMING === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DAYDREAMING: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        DAYDREAMING: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.DAYDREAMING === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.DAYDREAMING !== "DEFAULT" || dmsLevel || formDataCamera?.dms?.level === "LITE"}
                        className={(formDataCamera?.eventLevel?.DMS?.DAYDREAMING !== "DEFAULT" || dmsLevel || formDataCamera?.dms?.level === "LITE") ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
                <Grid item xs={5} style={{ display: 'flex', alignItems: 'center' }}>
                    {messages['cameraSetup_asleep']}
                    {
                        formDataCamera?.dms?.level === "LITE" &&
                        <Tooltip title={messages['cameraSetup_requires_dms_camera']} placement="bottom">
                            <Icon className="camera-setup-helper-icon">help</Icon>
                        </Tooltip>
                    }
                </Grid>
                <Grid item xs={3}>
                    <Toggle
                        id="asleep-trigger"
                        optionLabels={[messages['cameraSetup_on'], messages['cameraSetup_off']]}
                        onChange={(value) => {
                            let asleep = value ? "DEFAULT" : "OFF"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        ASLEEP: asleep
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                eventLevel: {
                                    ...prevData?.eventLevel,
                                    DMS: {
                                        ...prevData?.eventLevel?.DMS,
                                        ASLEEP: asleep
                                    }
                                }
                            }));
                        }}
                        checked={formDataCamera?.eventLevel?.DMS?.ASLEEP === "DEFAULT" ? true : false}
                        labelPosition="left"
                        style={{ display: 'flex' }}
                        isDisabled={dmsLevel || formDataCamera?.dms?.level === "LITE"}
                    />
                </Grid>
                <Grid item xs={3}></Grid>
                <Grid item xs={1}>
                    <IconButton
                        icon={formDataCamera?.sounds?.dms?.ASLEEP === "on" ? "volume_up" : "volume_off"}
                        onClick={() => {
                            let sound = formDataCamera?.sounds?.dms?.ASLEEP === "on" ? "off" : "on"
                            setFormDataCamera((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        ASLEEP: sound
                                    }
                                }
                            }));
                            setCameraChanges((prevData) => ({
                                ...prevData,
                                sounds: {
                                    ...prevData?.sounds,
                                    dms: {
                                        ...prevData?.sounds?.dms,
                                        ASLEEP: sound
                                    }
                                }
                            }));
                        }}
                        style={{ color: (formDataCamera?.sounds?.dms?.ASLEEP === "on" && !dmsLevel) && '#66bb6a' }}
                        isDisabled={formDataCamera?.eventLevel?.DMS?.ASLEEP !== "DEFAULT" || dmsLevel || formDataCamera?.dms?.level === "LITE"}
                        className={(formDataCamera?.eventLevel?.DMS?.ASLEEP !== "DEFAULT" || dmsLevel || formDataCamera?.dms?.level === "LITE") ? "camera-setup-sounds-disabled" : ''}
                    />
                </Grid>
            </Grid>
        </div>
    )
}
export default DMS